import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import WorkerDashboard from '@worker/pages/WorkerDashboard/WorkerDashboard';
import { BASE_PATH, isProduction } from '@utils/Environment';
import { LoginRedirect, ThLoading } from '@components/elements';
import { googleManager } from '@utils/GoogleTagManager';
import { useEffect } from 'react';
import NotFound from '@components/elements/NotFound';
import { isMobile } from 'react-device-detect';
import { LeaveReview } from '@worker/pages/LeaveReview';
import WorkerProfilePage from '@worker/pages/WorkerProfilePage/WorkerProfilePage';
import Survey from '@worker/pages/Survey/Survey';
import SurveySuccess from '@worker/pages/Survey/SurveySuccess';
import SurveyFailure from '@worker/pages/Survey/SurveyFailure';
import SurveyMobile from '@worker/pages/SurveyMobile/SurveyMobile';
import { useWorkerProfileContext } from '@worker/state/workerProfileContext';
import THNavbar from '@worker/components/layout/THNavbar/THNavbar';
import { SurveyProvider } from '@worker/state/surveyContext';
import MyJobs from '@worker/pages/MyJobs/MyJobs';
import WorkerInbox from '@worker/pages/WorkerInbox/WorkerInbox';
import CheckoutConfirmation from '@worker/pages/CheckoutConfirmation/CheckoutConfirmation';

export default function WorkerRoutes() {
  const { isLoadingWorkerProfile, surveysEnabled } = useWorkerProfileContext();
  const location = useLocation();

  useEffect(() => {
    if (isProduction() && location?.pathname !== undefined) {
      googleManager.page({
        url: location.pathname,
      });
    }
  }, [location.pathname]);

  if (isLoadingWorkerProfile) {
    return <ThLoading />;
  }

  return (
    <>
      <THNavbar />
      <Routes>
        <>
          <Route
            path={BASE_PATH}
            element={<Navigate to={`${BASE_PATH}dashboard`} replace />}
          />
          <Route path={`${BASE_PATH}dashboard`} element={<WorkerDashboard />} />
          <Route path={`${BASE_PATH}login`} element={<LoginRedirect />} />
          <Route
            path={`${BASE_PATH}reviews/:jobAssignmentId?`}
            element={<LeaveReview />}
          />
          {surveysEnabled && (
            <Route
              path={`${BASE_PATH}survey`}
              element={
                <SurveyProvider>
                  {isMobile ? <SurveyMobile /> : <Survey />}
                </SurveyProvider>
              }
            />
          )}
          <Route
            path={`${BASE_PATH}survey/success`}
            element={<SurveySuccess />}
          />
          <Route
            path={`${BASE_PATH}survey/failure`}
            element={<SurveyFailure />}
          />
          <Route
            path={`${BASE_PATH}workerProfile/view`}
            element={<WorkerProfilePage />}
          />
          <Route
            path={`${BASE_PATH}checkoutV2/confirmSession`}
            element={<CheckoutConfirmation />}
          />
          <Route
            path={`${BASE_PATH}checkoutV2/cancelSession`}
            element={<Navigate to={`${BASE_PATH}jobs/my-jobs/new`} replace />}
          />
          <Route
            path={`${BASE_PATH}inbox/:activeTab?`}
            element={<WorkerInbox />}
          />
          <Route
            path={`${BASE_PATH}jobs/:jobScope?/:tabName?`}
            element={<MyJobs />}
          />
          <Route path="*" element={<NotFound />} />
        </>
      </Routes>
    </>
  );
}
